<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('warehourse.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('warehourse.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('warehourse.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'branch.branch_name_en'
        }"
        :expandable="true"
      >
        <template v-slot="{ record }">
          <td
            :class="record.is_deleted ? 'ts-line-through ts-text-red-600' : ''"
          >
            {{ record.branch ? record.branch.branch_name_en : '' }}
          </td>
          <td
            :class="record.is_deleted ? 'ts-line-through ts-text-red-600' : ''"
          >
            {{ record.location_name_kh }}
          </td>
          <td
            :class="record.is_deleted ? 'ts-line-through ts-text-red-600' : ''"
          >
            {{ record.location_name_en }}
          </td>
          <td
            :class="record.is_deleted ? 'ts-line-through ts-text-red-600' : ''"
            class="ts-text-center"
          >
            {{ record.product_warranty_day }}
          </td>

          <td>
            <span
              class="badge badge-success"
              v-if="record.is_main_warehouse"
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >Yes</span
            >
            <span
              class="badge badge-danger"
              v-else
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >No</span
            >
          </td>
          <td class="ts-text-center">
            <span
              class="badge badge-success"
              v-if="record.sale_type == 'Wholesale'"
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >Dealer Price</span
            >
            <span
              class="badge badge-success"
              v-if="record.sale_type == 'Retail'"
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >Digital Price</span
            >
          </td>
          <td class="ts-text-center">
            <span class="badge badge-success">{{
              record.default_user_count
            }}</span>
          </td>
          <td class="ts-text-center">
            <span
              class="badge badge-success"
              v-if="record.is_transfer_approval_one_time"
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >Yes</span
            >
            <span
              class="badge badge-danger"
              v-else
              :class="
                record.is_deleted ? 'ts-line-through ts-text-red-600' : ''
              "
              >No</span
            >
          </td>
          <td
            :class="record.is_deleted ? 'ts-line-through ts-text-red-600' : ''"
            class="ts-text-center ts-uppercase"
          >
            {{ record.company_name }}
          </td>
          <td class="text-center ts-space-x-3">
            <a
              v-if="!record.is_deleted"
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
              v-if="!record.is_deleted"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
        <div slot="expand" slot-scope="prop">
          <table class="ts-w-11/12 ts-mx-auto detail">
            <thead>
              <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                  {{ $t('warehourse.no') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap">
                  {{ $t('warehourse.cardID') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap">
                  {{ $t('warehourse.employeeName') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                  {{ $t('warehourse.sex') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap">
                  {{ $t('warehourse.phone') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="ts-border-b-2"
                v-for="(detail, index) in prop.record.default_user"
                :key="index"
              >
                <td class="ts-p-2 ts-whitespace-nowrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap">
                  {{ detail.employee ? detail.employee.card_id : '' }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap">
                  {{ detail.employee ? detail.employee.employee_name_en : '' }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap ts-text-center">
                  {{ detail.employee ? detail.employee.sex : '' }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap">
                  {{ detail.employee ? detail.employee.phone : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('warehourse.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action
          @cancel="() => (showForm = false)"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'warehourseIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
  },
  computed: {
    ...mapState('stock/warehourse', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.stock.warehourse.search
      },
      set (newValue) {
        this.$store.commit('stock/warehourse/SET_SEARCH', newValue)
        this.$store.commit('stock/warehourse/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('warehourse.branch') },
        { name: this.$t('warehourse.nameKh') },
        { name: this.$t('warehourse.nameEn') },
        {
          name: this.$t('warehourse.productWarranty'),
          style: 'text-align:center;'
        },
        { name: this.$t('warehourse.isMain') },
        {
          name: this.$t('warehourse.saleType'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('warehourse.defaultUser'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('warehourse.isTransferApprovalOneTime'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('warehourse.companyName'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    },
    branch_id: {
      get () {
        return this.$store.state.stock.warehourse.branch_id
      },
      set (newValue) {
        this.$store.commit('stock/warehourse/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    getBranch () {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/warehourse/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.$store.commit('stock/warehourse/SET_EDIT_DATA', {})
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('stock/warehourse/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('stock/warehourse/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('stock/warehourse/destroy', record.location_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    branch_id: debounce(function () {
      this.fetchData(this.search)
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/warehourse/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
